/* istanbul ignore file */

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { DeliveryMethod } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SortableDeliveryMethod = props => {
  const theme = useTheme()
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props?.data?.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.SortableDeliveryMethodContainer ref={setNodeRef} style={style}>
      <DotsSixVerticalIcon
        size={24}
        id="draggable-icon"
        data-testid="draggable-icon"
        dragging={props.dragging}
        {...attributes}
        {...listeners}
      />
      <DeliveryMethod
        {...props}
        index={props.position}
        containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16} ${theme.spacing.sp16}`}
      />
    </Styles.SortableDeliveryMethodContainer>
  )
}

export default SortableDeliveryMethod
